const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'type', label: 'Solution'},
    { key: 'title', label: 'Title', sortable: true },
    { key: 'created_at', label: 'Date', sortable: true },
    // { key: 'func', label: 'Detail', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'type', label: '솔루션'},
    { key: 'title', label: '제목', sortable: true },
    { key: 'created_at', label: '일시', sortable: true },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'type', label: 'ソリューション'},
    { key: 'title', label: 'タイトル', sortable: true },
    { key: 'created_at', label: '日付', sortable: true },
  ]
}

const fields = {
  i18n_fields
}

export default fields